import { FieldEditorProps } from './FieldEditorProps';
import '../styles/Editors.scoped.scss';

export const ColumnFieldEditor = ({ field, onChange }: FieldEditorProps) => {

    const columnOptions = [
        { label: 'Name', value: 'name'},
        { label: 'Membership Number', value: 'external_id'},
        { label: 'Email', value: 'email'},
    ];

    return <div className="field-editor-row">
        <label>Field</label>
        <div className='field-editor-input'>
            <select
                className="source-selector"
                onChange={(e) => onChange({column: e.target.value === "" ? null : e.target.value})}
                value={field?.column || ''}
                >
                <option key={null} value={''}>
                    Select a field
                </option>
                {columnOptions.map(({label, value}) => (
                <option key={value} value={value}>
                {label}
                </option>
                ))}
            </select>
        </div>
    </div>
}